import { QuestionAnswerRecord } from '../../../../types/dato';
import { Question } from 'schema-dts';
import { siteUrl } from '..';

export const faq = (
  data: QuestionAnswerRecord[],
  uri: string,
  localeCode: string,
  id: string,
): Question[] => {
  const questions: Question[] = [];
  data?.forEach((item) => {
    const question = item?.question;
    const answer =
      item?.answer?.value?.document?.children?.[0]?.children?.[0]?.value;

    if (answer && question) {
      questions.push({
        '@type': 'Question',
        '@id': `${siteUrl}${uri}#${id}-${questions.length + 1}`,
        position: questions.length + 1,
        url: `${siteUrl}${uri}#${id}-${questions.length + 1}`,
        name: question,
        answerCount: 1,
        acceptedAnswer: {
          '@type': 'Answer',
          text: answer,
          inLanguage: localeCode,
        },
        inLanguage: localeCode,
      });
    }
  });

  return questions;
};
